
import { FocusEvent, ChangeEvent } from "react"
import styled from "@emotion/styled"

import ErrorIcon from "../ui/images/error-icon"
import { SerializedStyles } from "@emotion/react"

const FormGroup = styled.div<{ customStyles?: SerializedStyles }>`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  ${(props) => props.customStyles}
`

const LabelWrapper = styled.div<{ customStyles?: SerializedStyles }>`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${(props) => props.customStyles}
`

const Label = styled.label<{ customStyles?: SerializedStyles }>`
  font-family: Nunito;
  font-weight: 600;
  font-size: 13.33px;
  line-height: 140%;
  color: #1f2425;

  ${(props) => props.customStyles}
`

const Input = styled.input<{ customStyles?: SerializedStyles }>`
  border: 1px solid ${(props: any) => props.hasError ? "#e76a6a" : "#e8e8e8"};
  border-radius: 5px;
  padding: 10px;
  @media (max-width: 425px) {
    width: 368px;
    height: 50px;
  }

  ${(props) => props.customStyles}
`

const Error = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  color: #e76a6a;
  font-weight: 600;
  font-size: 13px;
  line-height: 140%;
  padding: 0.5rem 0;
  max-width: 352px;
  @media (max-width: 812px) {
    max-width: 300px;
  }
`

const ErrorMessage = styled.span`
  padding-top: 3px;
  margin-left: 0.5rem;
`

export interface Props {
  label: string
  sublabel?: string | React.ReactNode
  name: string
  placeholder?: string
  type?: string
  tabIndex?: number | null
  value?: string
  style?: SerializedStyles
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void
  hasError?: boolean | ""
  errorMessage?: string
  styleLabel?: SerializedStyles
  styleGroup?: SerializedStyles
  styleLabelWrapper?: SerializedStyles
  id?: any
}

const CustomInput = ({
  label,
  sublabel,
  name,
  placeholder,
  type = "text",
  tabIndex = null,
  value,
  style,
  styleLabel,
  onChange,
  onBlur,
  hasError,
  errorMessage,
  id,
  styleGroup,
  styleLabelWrapper,
}: Props) => {
  const othersProps: { tabIndex?: number } = {}

  if (tabIndex) {
    othersProps.tabIndex = tabIndex
  }

  return (
    <FormGroup customStyles={styleGroup}>
      <LabelWrapper customStyles={styleLabelWrapper}>
        <Label htmlFor={name} customStyles={styleLabel}>
          {label}
        </Label>
        {sublabel}
      </LabelWrapper>

      <Input
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        customStyles={style}
        // @ts-ignore
        hasError={hasError}
        onChange={onChange}
        onBlur={onBlur}
        id={id}
        {...othersProps}
      />

      {hasError && (
        <Error>
          {<ErrorIcon />} <ErrorMessage>{errorMessage}</ErrorMessage>
        </Error>
      )}
    </FormGroup>
  )
}

export default CustomInput
